import { RemoveBulkByLineItemKeysRequest } from '../selection-list/removeBulkFromListByLineItemKeys';
import { convertLineItemKeysToDto } from '../../shared/utils/convertLineItemKey';
import { removeProductsFromCartByLineItemKeys } from './removeProductsFromCartByLineItemKeys';
import { globalErrorResponse } from '../../shared/notification/actions';
import { invalidateCartSummaryQuery } from './useCartSummaryQuery';
import { invalidateCartGroupedItems } from './useCartGroupedItems';
import { invalidateShoppingCartProducts } from './useShoppingCartProducts';
import { invalidateCartAggregations } from '../../shop/cart/useCartAggregations';
import { useTranslation } from 'react-i18next';
import { UnavailableProductOut } from '../../store/api';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { showNotification } from '../../shared/notification/toastNotification';

interface RemoveFromCartArgs {
    unavailableProducts: UnavailableProductOut[];
}

export const useRemoveUnavailableProductsFromCartMutation = () => {
    const { t } = useTranslation();

    return useMutation(
        ({ unavailableProducts }: RemoveFromCartArgs) => {
            const productSelection = {
                included: unavailableProducts.map(({ lineItemKey }) => lineItemKey)
            };
            const body: RemoveBulkByLineItemKeysRequest = {
                lineItemKeys: convertLineItemKeysToDto(productSelection.included)
            };
            return removeProductsFromCartByLineItemKeys(body);
        },
        {
            onSuccess: () => {
                showNotification(t('notifications.removeFromCart.success'));
                invalidateCartSummaryQuery().then();
                invalidateCartGroupedItems().then();
                invalidateShoppingCartProducts().then();
                invalidateCartAggregations().then();
            },
            onError: (error: AxiosError) => {
                globalErrorResponse(error);
            }
        }
    );
};
